export const Backward10 = () => (
  <svg
    className='h-5 w-5 scale-[1.4] sm:h-[18px] sm:w-[18px]'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.25'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8' />
    <path d='M3 3v5h5' />
    <text
      x='12.5'
      y='15'
      fontSize='9'
      fontWeight='bold'
      stroke='none'
      fill='currentColor'
      textAnchor='middle'
    >
      10
    </text>
  </svg>
);
